import DoospNav from "./DoospNav";
import DoospFooter from "./DoospFooter";

export default function DoospLayout({ children, mainClassName = "" }) {
  return (
    <div className="min-h-screen flex flex-col bg-[#FAFAFA] text-zinc-900">
      <DoospNav />
      <main className={`flex-1 ${mainClassName}`}>{children}</main>
      <DoospFooter />
    </div>
  );
}
